import {
    CustomPIXIComponent,
} from "react-pixi-fiber";

interface IProps {
    currentTime: number,
    offsetX: number,
    zoom: number,
}

export const Playhead = CustomPIXIComponent<IProps, PIXI.Graphics>({
    customApplyProps: (instance, _, {
        currentTime,
        offsetX,
        zoom,
    }) => {
        instance.lineStyle(1, 0xFF0000)
        instance.moveTo(0, 25);
        instance.lineTo(0, 130);

        instance.beginFill(0xFF0000)
        instance.moveTo(0, 25);
        instance.lineTo(7, 15);
        instance.lineTo(-7, 15);
        instance.lineTo(0, 25);
        instance.endFill();

        instance.position.set(currentTime * zoom + offsetX, 0);
    },
    customDisplayObject: () => new PIXI.Graphics(),
}, 'Playhead');

export default Playhead;



// WEBPACK FOOTER //
// ./src/components/Player/Playhead.tsx